<template>
  <section class="price">
    <div class="container">
      <div class="price-top">
        <h2>Стоимость проекта</h2>
      </div>
      <div class="price-bottom">
        <div class="row">
          <div class="col">
            <h3>Узнайте стоимость дизайн-проекта, ответив на 3 вопроса</h3>
            <p>Пройдите короткий тест, узнайте цену, получите консультацию по будущему проекту</p>
            <div><button class="button button_small" @click="openQuiz ()">Узнать стоимость</button></div>
          </div>
          <div class="col">
              <div class="col-top">
                <picture>
                  <source srcset="../../public/static/images/sectionPrice/i1.webp">
                  <img src="../../public/static/images/sectionPrice/i1.png" alt="">
                </picture>
              </div>
            <div class="col-bottom">
              <p>Бонусы:</p>
              <ul>
                <li>чек листы на 5 ошибок в строительстве</li>
                <li>5 трендов 2021 года на дизайн интерьеров</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: 'SectionPrice',
  components: {
  },
  methods: {
    ...mapActions(['plusQuiz']),
    openQuiz () {
      this.plusQuiz()
    }
  },
  computed: {
  },
  mounted() {
  }
}
</script>

<style scoped lang='scss'>
.price {
  background-color: #eee;
  padding: 45px 0;
  @media (max-width: 575.98px) {
    padding: 20px 0;
  }
  &-top {
    position: relative;
    margin-bottom: 30px;
    padding-bottom: 1px;
  }
  &-bottom {
    .row {
      display: flex;
      justify-content: center;
      padding-top: 20px;
      margin: 0 -40px;
      @media (max-width: 1199.98px) {
        flex-wrap: wrap;
      }
      .col {
        box-sizing: border-box;
        padding: 0 40px;
      }
      .col:first-child {
        max-width: 50%;
        flex: 0 0 50%;
        display: flex;
        flex-direction: column;
        @media (max-width: 1199.98px) {
          flex: 1 1 100%;
          max-width: 100%;
          margin-bottom: 20px;
        }
        h3 {
          font-size: 3.2rem;
          font-weight: 400;
          margin-bottom: 40px;
        }
        p {
          font-weight: 300;
          font-size: 2.2rem ;
          color: #333333;
          margin-bottom: 50px;
          flex: 1 1 auto;
        }
        button {
          font-weight: 200;
          @media (max-width: 575.98px) {
            width: 100%;
          }
        }
      }
      .col:last-child {
        max-width: 40%;
        flex: 0 0 40%;
        position: relative;
        @media (max-width: 1199.98px) {
          flex: 1 1 100%;
          max-width: 100%;
        }
        .col-top {
          height: auto;
          width: 100%;
          overflow: hidden;
          margin-bottom: 30px;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            object-position: center;
          }
        }
        .col-bottom {
          p {
            font-size: 2.8rem;
          }
          li {
            position: relative;
            font-weight: 300;
            font-size: 2.2rem;
            color: #333333;
            padding-left: 17px;
            max-width: 300px;
            margin-bottom: 10px;
            &:last-child {
              margin-bottom: 0;
            }
            &:before {
              position: absolute;
              content: '';
              top: 5px;
              left: 0;
              width: 10px;
              height: 10px;
              background-color: #0E0E0E;
            }
          }
        }
      }
    }
  }
}
</style>
